module.exports = __webpack_public_path__ + "static/media/white_plus_big.3ff6c2a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/white_plus_big.svg
// module id = 274
// module chunks = 0